<template>
  <router-link
    :to="{ name: item.name }"
    v-slot="{ href, navigate, isExactActive }"
    custom
  >
    <li
      aria-haspopup="true"
      data-menu-toggle="hover"
      class="menu-item text-dark-50 text-hover-dark font-weight-bolder poppins"
      @click.passive="hideSideBar()"
    >
      <a :href="href" class="menu-link" @click="navigate">
        <!--        <v-icon>{{ item.icon }}</v-icon>-->
        <div class="menu-text ms-3">
          <span class="position-relative text-hover-dark">
            <!--  plus nav item for unsubscribed users                  style="color: #c5caec !important;"-->
            {{ $t(item.title) }}

            <!--            <inline-svg-->
            <!--              class="position-absolute purple-plus-star"-->
            <!--              style="width: 16px; top: -6px; right: -14px"-->
            <!--              src="/img/plus/plus_star.svg"-->
            <!--            />-->
          </span>
        </div>
      </a>
    </li>
  </router-link>
</template>

<script>
import eventBus from "@/core/services/eventBus";
export default {
  name: "Navi",
  props: ["item"],
  data: () => ({
    activeSubmenu: null,
  }),
  methods: {
    hideSideBar() {
      eventBus.$emit("toggleAside");
    },
  },
};
</script>

<style scoped lang="scss">
.purple-plus-star {
  //color: #7e8299 !important;
  //svg {
  fill: #90f !important;
  //}
}

.light-gray-plus-star {
  //color: #c5caec !important;
  //svg {
  fill: #c5caec !important;
  //}
}
</style>
